export enum BITACORA_TYPES {
  BITACORA_SET_HISTORIAL_RESULT = 'BITACORA_SET_HISTORIAL_RESULT',
  BITACORA_CLEAR_MODULE = 'BITACORA_CLEAR_MODULE',
}
